import http from '@/common/utils/http-common';
import Company from '@/types/Company.type';

class CompanyService {
  get() {
    return http.get(`/companies/`);
  }

  update(data: Company) {
    return http.put(`/companies/`, data);
  }

  agreeUpdate() {
    return http.put(`/companies/agreeUpdate/`);
  }

}

export default new CompanyService();
